import React, { FunctionComponent, useContext, useCallback } from 'react';
import { AuthStore, removeAuth } from '../../context';
import styled from 'styled-components';
import { withAlpha } from '../../util/color.util';
import { history } from '../../history';

const Container = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;

  > * {
    margin-bottom: 1rem;
  }

  h1 {
    margin: 0;
    font-size: 6rem;
    font-weight: 300;
    line-height: 1.2;
    text-align: center;
  }
`;

const Button = styled.button`
  color: #007bff;
  appearance: none;
  -webkit-appearance: none;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
  background-color: transparent;
  background: transparent;
  font-size: 14px;
  border: none;
  cursor: pointer;

  &:hover,
  &:focus {
    text-decoration: underline;
    color: ${withAlpha('#007bff', 0.6)};
  }
`;

export const ErrorPage: FunctionComponent<{ match: any }> = props => {
  const { dispatch } = useContext(AuthStore);
  const status =
    (props.match && props.match.params && props.match.params.status) || 404;

  const renderContent = useCallback(() => {
    switch (status) {
      case '401':
        return (
          <>
            <span>Authorization Error</span>
            <Button
              id="error-go-back-button"
              data-testid="error-go-back-button"
              onClick={() => history.goBack()}
            >
              Go back
            </Button>
            <Button
              onClick={() => {
                dispatch(removeAuth());
                history.push('/logout');
              }}
              id="error-login-button"
              data-testid="error-login-button"
            >
              Log back in
            </Button>
          </>
        );
      case '404':
        return (
          <>
            <span>Page not found</span>
            <Button
              onClick={() => history.goBack()}
              id="error-go-back-button"
              data-testid="error-go-back-button"
            >
              Go back
            </Button>
          </>
        );
      default:
        return (
          <>
            <span>Looks like there was an error. Sorry about that.</span>
            <Button
              onClick={() => history.goBack()}
              id="error-go-back-button"
              data-testid="error-go-back-button"
            >
              Go back
            </Button>
          </>
        );
    }
  }, [status, dispatch]);

  return (
    <Container>
      <h1>{status}</h1>
      {renderContent()}
    </Container>
  );
};
